import { AxiosError } from 'axios'

type HandleErrorMessage = {
  fallbackMessage?: string
  error:
    | {
        message: string
      }
    | string
}

export const handleErrorMessage = ({
  error,
  fallbackMessage
}: HandleErrorMessage) => {
  if (typeof error === 'string') return error

  if (error?.message) return error.message

  return fallbackMessage || 'Houve um erro'
}

//
export const formatAxiosError = (error: AxiosError<APIErrorRawResponse>) => {
  if (typeof error !== 'object' || !error.response) {
    return error.toString()
  }

  const { status, data } = error.response || {}
  const errorMessage = `HTTP Status ${status}`

  if (typeof data !== 'object' || data === null) {
    return errorMessage
  }

  if ('message' in data || 'error_id' in data) {
    const message =
      (data as BffError)?.message || (data as DefaultErrors)?.messages?.[0]

    const errorId = (data as BffError)?.error_id

    if (errorId && message) {
      return `${message} (ID: ${errorId})`
    }

    if (errorId) {
      return `Erro ID: ${errorId}`
    }

    if (message) {
      return `${message}`
    }
  }

  /**
   * Tratando um caso inesperado da API
   * {
   * "messages": [
   *  {
   *      "name": "ValidationError",
   *      "error": "Products not found. SKU: ",
   *      "property": "products"
   *  }
   *    ]
   *}
   */
  if ('messages' in data) {
    const message = data?.messages?.[0]
    if (typeof message === 'object' && message !== null) {
      return (
        (message as any).error ||
        (message as any).message ||
        (message as any).messages?.[0] ||
        'Error'
      )
    }

    return data?.messages?.[0] || errorMessage
  }

  return errorMessage
}
